import { Button, Group, Icon, Text } from '@inflearn/ds-react';
import { faChevronRight } from '@inflearn/pro-regular-svg-icons';

interface Props {
  dateLabel: string;
  date: string;
  href: string;
}

export function GiftItemHeader({ dateLabel, date, href }: Props) {
  return (
    <Group position="apart" align="center">
      <Group spacing={4}>
        <Text size="sm" weight={500} color="dark.6">
          {dateLabel}
        </Text>
        <Text size="sm" weight={700} color="gray.9">
          {date}
        </Text>
      </Group>
      <Button
        component="a"
        href={href}
        variant="transparent"
        size="xs"
        radius="md"
        css={{
          '&&': {
            paddingLeft: 7,
            paddingRight: 7,
          },
        }}
        rightIcon={<Icon icon={faChevronRight} size="xs" />}
      >
        자세히 보기
      </Button>
    </Group>
  );
}
